export default function getImgDataURL(imageSelector, opacity = 1, improvementMultiplier = 1) {
  const imageElement = document.querySelector(imageSelector)

  if (!imageElement) {
    throw `No element by the given selector: "${ imageSelector }"`
  }

  imageElement.crossOrigin = "anonymous"

  const canvas = document.createElement('canvas')
  const ctx = canvas.getContext('2d')

  const imageWidth = imageElement.clientWidth
  const imageHeight = imageElement.clientHeight

  const improvementImageWidth = imageWidth * improvementMultiplier
  const improvementImageHeight = imageHeight * improvementMultiplier

  canvas.width = improvementImageWidth
  canvas.height = improvementImageHeight

  ctx.globalAlpha = opacity
  ctx.drawImage(imageElement, 0, 0, improvementImageWidth, improvementImageHeight)

  return {
    dataUrl: canvas.toDataURL(),
    imageWidth,
    imageHeight
  }
}